var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenedTabs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 653.146,
    height: 396.47,
    viewBox: "0 0 653.146 396.47",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-288 -252.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "matrix(0.839, -0.545, 0.545, 0.839, -851.767, -5983.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_561-1126",
    "data-name": "Path 561",
    d: "M434.056,197.674H233.67a2.881,2.881,0,0,0-2.879,2.879V336.34a2.881,2.881,0,0,0,2.879,2.879H434.056a2.876,2.876,0,0,0,2.189-1.01.669.669,0,0,0,.063-.079,2.7,2.7,0,0,0,.413-.7,2.808,2.808,0,0,0,.218-1.093V200.553A2.882,2.882,0,0,0,434.056,197.674Zm2.06,138.666a2.039,2.039,0,0,1-.34,1.129,2.129,2.129,0,0,1-.779.7,2.042,2.042,0,0,1-.941.228H233.67a2.059,2.059,0,0,1-2.057-2.057V200.553a2.059,2.059,0,0,1,2.057-2.057H434.056a2.06,2.06,0,0,1,2.06,2.057Z",
    transform: "translate(-2405.791 5984.326)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 205.323,
    height: 0.823,
    transform: "translate(-2174.59 6193.538)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 2.469,
    cy: 2.469,
    r: 2.469,
    transform: "translate(-2170.064 6185.703)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 2.469,
    cy: 2.469,
    r: 2.469,
    transform: "translate(-2162.966 6185.703)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 2.469,
    cy: 2.469,
    r: 2.469,
    transform: "translate(-2155.868 6185.703)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583-1127",
    "data-name": "Path 583",
    d: "M344.945,347.5H293.029a2.525,2.525,0,0,1,0-5.049h51.916a2.525,2.525,0,0,1,0,5.049Z",
    transform: "translate(-2445.791 5887.343)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584-1128",
    "data-name": "Path 584",
    d: "M370.968,362.93H281.834a.33.33,0,1,1,0-.66h89.134a.33.33,0,0,1,0,.66Z",
    transform: "translate(-2439.762 5874.067)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585-1129",
    "data-name": "Path 585",
    d: "M344.945,411.551H293.029a2.525,2.525,0,0,1,0-5.049h51.916a2.525,2.525,0,0,1,0,5.049Z",
    transform: "translate(-2445.791 5844.438)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586-1130",
    "data-name": "Path 586",
    d: "M370.968,426.98H281.834a.33.33,0,1,1,0-.66h89.134a.33.33,0,1,1,0,.66Z",
    transform: "translate(-2439.762 5831.162)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587-1131",
    "data-name": "Path 587",
    d: "M344.945,475.6H293.029a2.525,2.525,0,0,1,0-5.049h51.916a2.525,2.525,0,0,1,0,5.049Z",
    transform: "translate(-2445.791 5801.532)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588-1132",
    "data-name": "Path 588",
    d: "M370.968,491.029H281.834a.33.33,0,1,1,0-.66h89.134a.33.33,0,0,1,0,.66Z",
    transform: "translate(-2439.762 5788.257)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_552-1133",
    "data-name": "Path 552",
    d: "M792.253,565.923a10.091,10.091,0,0,1,1.411.787l44.852-19.143,1.6-11.815,17.922-.11-1.059,27.1L797.78,578.4a10.6,10.6,0,0,1-.448,1.208,10.235,10.235,0,1,1-5.079-13.682Z",
    transform: "translate(-246.576 -174.461)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553-1134",
    "data-name": "Path 553",
    d: "M636.98,735.021H624.72l-5.832-47.288h18.094Z",
    transform: "translate(-19 -98)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554-1135",
    "data-name": "Path 554",
    d: "M615.963,731.518h23.644V746.4H601.076a14.887,14.887,0,0,1,14.887-14.887Z",
    transform: "translate(-19 -98)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555-1136",
    "data-name": "Path 555",
    d: "M684.66,731.557l-12.2,1.2-10.441-46.488,18.007-1.774Z",
    transform: "translate(-19 -98)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556-1137",
    "data-name": "Path 556",
    d: "M891.686,806.128H915.33v14.887H876.8a14.887,14.887,0,0,1,14.887-14.887Z",
    transform: "translate(-322.009 -82.709) rotate(-5.625)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 24.561,
    cy: 24.561,
    r: 24.561,
    transform: "translate(596.832 262.013)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557-1138",
    "data-name": "Path 557",
    d: "M849.556,801.919a4.471,4.471,0,0,1-4.415-3.7C838.8,763,818.053,647.817,817.557,644.626a1.432,1.432,0,0,1-.016-.222v-8.588a1.489,1.489,0,0,1,.279-.872l2.74-3.838a1.479,1.479,0,0,1,1.144-.625c15.622-.732,66.784-2.879,69.256.209h0c2.482,3.1,1.605,12.507,1.4,14.36l.01.193,22.985,147a4.512,4.512,0,0,1-3.715,5.135l-14.356,2.365a4.521,4.521,0,0,1-5.025-3.093c-4.44-14.188-19.329-61.918-24.489-80.387a.5.5,0,0,0-.981.139c.258,17.606.881,62.523,1.1,78.037l.023,1.671a4.518,4.518,0,0,1-4.093,4.536L849.976,801.9C849.836,801.914,849.7,801.919,849.556,801.919Z",
    transform: "translate(-246.576 -174.461)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99-1139",
    "data-name": "Path 99",
    d: "M852.381,495.254c-4.286,2.548-6.851,7.23-8.323,12a113.683,113.683,0,0,0-4.884,27.159l-1.556,27.6-19.255,73.17c16.689,14.121,26.315,10.911,48.781-.639s25.032,3.851,25.032,3.851l4.492-62.258,6.418-68.032a30.169,30.169,0,0,0-4.862-4.674,49.659,49.659,0,0,0-42.442-9Z",
    transform: "translate(-246.576 -174.461)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558-1140",
    "data-name": "Path 558",
    d: "M846.127,580.7a10.527,10.527,0,0,1,1.5.7l44.348-22.2.736-12.026,18.294-1.261.98,27.413-59.266,19.6a10.5,10.5,0,1,1-6.593-12.232Z",
    transform: "translate(-246.576 -174.461)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101-1141",
    "data-name": "Path 101",
    d: "M902.766,508.411c10.911,3.851,12.834,45.574,12.834,45.574-12.837-7.06-28.241,4.493-28.241,4.493s-3.209-10.912-7.06-25.032a24.53,24.53,0,0,1,5.134-23.106S891.854,504.558,902.766,508.411Z",
    transform: "translate(-246.576 -174.461)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102-1142",
    "data-name": "Path 102",
    d: "M889.991,467.531c-3.06-2.448-7.235,2-7.235,2L880.308,447.5s-15.3,1.833-25.094-.612-11.323,8.875-11.323,8.875a78.583,78.583,0,0,1-.306-13.771c.612-5.508,8.568-11.017,22.645-14.689s21.421,12.241,21.421,12.241C897.445,444.439,893.051,469.979,889.991,467.531Z",
    transform: "translate(-246.576 -174.461)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(2910 -5674.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_561-2-1143",
    "data-name": "Path 561",
    d: "M434.056,197.674H233.67a2.881,2.881,0,0,0-2.879,2.879V336.34a2.881,2.881,0,0,0,2.879,2.879H434.056a2.876,2.876,0,0,0,2.189-1.01.669.669,0,0,0,.063-.079,2.7,2.7,0,0,0,.413-.7,2.808,2.808,0,0,0,.218-1.093V200.553A2.882,2.882,0,0,0,434.056,197.674Zm2.06,138.666a2.039,2.039,0,0,1-.34,1.129,2.129,2.129,0,0,1-.779.7,2.042,2.042,0,0,1-.941.228H233.67a2.059,2.059,0,0,1-2.057-2.057V200.553a2.059,2.059,0,0,1,2.057-2.057H434.056a2.06,2.06,0,0,1,2.06,2.057Z",
    transform: "translate(-2405.791 5984.326)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99-2",
    "data-name": "Rectangle 99",
    width: 205.323,
    height: 0.823,
    transform: "translate(-2174.59 6193.538)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88-2",
    "data-name": "Ellipse 88",
    cx: 2.469,
    cy: 2.469,
    r: 2.469,
    transform: "translate(-2170.064 6185.703)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89-2",
    "data-name": "Ellipse 89",
    cx: 2.469,
    cy: 2.469,
    r: 2.469,
    transform: "translate(-2162.966 6185.703)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90-2",
    "data-name": "Ellipse 90",
    cx: 2.469,
    cy: 2.469,
    r: 2.469,
    transform: "translate(-2155.868 6185.703)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583-2-1144",
    "data-name": "Path 583",
    d: "M344.945,347.5H293.029a2.525,2.525,0,0,1,0-5.049h51.916a2.525,2.525,0,0,1,0,5.049Z",
    transform: "translate(-2445.791 5887.343)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584-2-1145",
    "data-name": "Path 584",
    d: "M370.968,362.93H281.834a.33.33,0,1,1,0-.66h89.134a.33.33,0,0,1,0,.66Z",
    transform: "translate(-2439.762 5874.067)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585-2-1146",
    "data-name": "Path 585",
    d: "M344.945,411.551H293.029a2.525,2.525,0,0,1,0-5.049h51.916a2.525,2.525,0,0,1,0,5.049Z",
    transform: "translate(-2445.791 5844.438)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586-2-1147",
    "data-name": "Path 586",
    d: "M370.968,426.98H281.834a.33.33,0,1,1,0-.66h89.134a.33.33,0,1,1,0,.66Z",
    transform: "translate(-2439.762 5831.162)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587-2-1148",
    "data-name": "Path 587",
    d: "M344.945,475.6H293.029a2.525,2.525,0,0,1,0-5.049h51.916a2.525,2.525,0,0,1,0,5.049Z",
    transform: "translate(-2445.791 5801.532)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588-2-1149",
    "data-name": "Path 588",
    d: "M370.968,491.029H281.834a.33.33,0,1,1,0-.66h89.134a.33.33,0,0,1,0,.66Z",
    transform: "translate(-2439.762 5788.257)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_561-3-1150",
    "data-name": "Path 561",
    d: "M474.659,197.674H234.245a3.457,3.457,0,0,0-3.454,3.454V364.039a3.457,3.457,0,0,0,3.454,3.454H474.659a3.451,3.451,0,0,0,2.626-1.212.8.8,0,0,0,.075-.095,3.236,3.236,0,0,0,.5-.836,3.37,3.37,0,0,0,.261-1.311V201.128A3.457,3.457,0,0,0,474.659,197.674Zm2.472,166.365a2.445,2.445,0,0,1-.408,1.355,2.554,2.554,0,0,1-.935.84,2.45,2.45,0,0,1-1.129.273H234.245a2.47,2.47,0,0,1-2.467-2.467V201.128a2.47,2.47,0,0,1,2.467-2.467H474.659a2.471,2.471,0,0,1,2.472,2.468Z",
    transform: "translate(57.209 173.542)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99-3",
    "data-name": "Rectangle 99",
    width: 246.338,
    height: 0.987,
    transform: "translate(288.492 385.058)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88-3",
    "data-name": "Ellipse 88",
    cx: 2.962,
    cy: 2.962,
    r: 2.962,
    transform: "translate(293.922 375.659)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89-3",
    "data-name": "Ellipse 89",
    cx: 2.962,
    cy: 2.962,
    r: 2.962,
    transform: "translate(302.438 375.659)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90-3",
    "data-name": "Ellipse 90",
    cx: 2.962,
    cy: 2.962,
    r: 2.962,
    transform: "translate(310.954 375.659)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589-1151",
    "data-name": "Path 589",
    d: "M923.117,453.186h-82.26a3.739,3.739,0,1,1,0-7.478h82.26a3.739,3.739,0,0,1,0,7.478Z",
    transform: "translate(-445.702 17.923)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590-1152",
    "data-name": "Path 590",
    d: "M869.368,419.186h-28.51a3.739,3.739,0,1,1,0-7.478h28.51a3.739,3.739,0,0,1,0,7.478Z",
    transform: "translate(-445.702 36.032)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 15.891,
    cy: 15.891,
    rx: 15.891,
    ry: 15.891,
    transform: "translate(342.006 443.883)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591-1153",
    "data-name": "Path 591",
    d: "M860.866,385.456H712.706a7.957,7.957,0,0,0-7.946,7.946v32.717a7.957,7.957,0,0,0,7.945,7.945H860.866a7.957,7.957,0,0,0,7.945-7.946V393.4a7.957,7.957,0,0,0-7.945-7.946Zm7.011,40.662a7.019,7.019,0,0,1-7.011,7.011H712.706a7.019,7.019,0,0,1-7.011-7.011V393.4a7.019,7.019,0,0,1,7.011-7.011H860.866a7.019,7.019,0,0,1,7.011,7.011Z",
    transform: "translate(-375.206 50.014)",
    fill: "#3f3d56"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedTabs);
export default __webpack_public_path__ + "static/media/opened_tabs.01b3562d032e2c217325633113c72703.svg";
export { ForwardRef as ReactComponent };